import L from "leaflet";
import { NavLeaf } from "../base/nav-leaf";
import { drawShipIcon } from "@/utils/shipIcon";
import * as utils from "@/utils/utils";

export class FolioLeaf extends NavLeaf {

    constructor() {
        super();
        this.cellsLayer = null;
        this.activeCell = null;
        this.allCells = null;
        this.shipMarker = null; // Маркер корабля
    }

    async init(el) {
        await super.init(el);
        
        if (!this.map) {
            console.error('FolioLeaf: map was not initialized after super.init()');
            return;
        }
        
        this.cellsLayer = L.layerGroup().addTo(this.map);

        // Добавляем группу для маршрутов
        this.routeGroup = L.layerGroup().addTo(this.map);

    }

    displayCell(cellData) {
        const cell = L.geoJSON(cellData, {
            style: {
                color: '#0ba30b',  // Ярко-зеленый цвет (без прозрачности)
                fillOpacity: 0.1,  // Очень легкая зеленая заливка
                fillColor: '#0ba30b', 
                weight: 2,         // Увеличили толщину до 2px
                opacity: 0.8       // 80% непрозрачности для четких линий
            },
            onEachFeature: (feature, layer) => {
                layer.on('click', () => {
                    this.highlightCell(feature.properties.id);
                });

                layer.bindTooltip(`${feature.properties.id}`, {
                    permanent: false,
                    direction: 'center'
                });
            }
        });

        cell.addTo(this.cellsLayer);
        return cell;
    }

    highlightCell(cellName) {
        if (!this.map) {
            console.warn('highlightCell: map is null, cannot highlight cell');
            return;
        }
        
        if (this.activeCell) {
            this.activeCell.setStyle({ 
                color: '#0ba30b',        // Ярко-зеленый 
                fillOpacity: 0.1,        // Легкая заливка
                fillColor: '#0ba30b', 
                weight: 2,               // Толщина 2px
                opacity: 0.8             // 80% непрозрачности
            });
        }

        const cell = this.allCells.find(c => c.id === cellName);


        if (cell) {
            // Create GeoJSON cell data
            let geometry = {
                type: "Polygon",
                coordinates: [
                    [
                        [cell.west, cell.north],
                        [cell.east, cell.north],
                        [cell.east, cell.south],
                        [cell.west, cell.south],
                        [cell.west, cell.north],
                    ],
                ],
            };

            if (cell.coverage) {
                const parsedGeom = utils.parseWKT(cell.coverage);
                if (parsedGeom) {
                    geometry = parsedGeom;
                }
            }

            const cellData = {
                type: "Feature",
                properties: {
                    id: cell.id,
                    name: cell.title || cell.name,
                    type: cell.type,
                },
                geometry: geometry,
            };

            const layer = this.displayCell(cellData);
            layer.setStyle({
                color: '#ff4444',       // Ярко-красный цвет для выделения
                weight: 3,              // Еще толще для активной ячейки
                opacity: 1,             // Полная непрозрачность
                fillOpacity: 0.15,      // Легкая красная заливка 
                dashArray: '8,4',       // Более заметные пунктиры (8px линия, 4px пробел)
                dashOffset: '0',
                fillColor: '#ff4444',   // Красная заливка
                fill: true,             // Включаем заливку
                stroke: true
            });
            layer.bringToFront();
            this.activeCell = layer;
            this.map.fitBounds(layer.getBounds());
        }

    }

    highlightCell1(cellId) {
        // Reset previous active cell style
        if (this.activeCell) {
            this.activeCell.setStyle(this.defaultStyle);
        }

        // Find and highlight new active cell
        this.cellsLayer.eachLayer(layer => {
            if (layer.feature && layer.feature.properties.id === cellId) {
                layer.setStyle(this.activeStyle);
                layer.bringToFront();
                this.activeCell = layer;
                this.map.fitBounds(layer.getBounds());
            }
        });
    }

    clearCells() {
        if (this.cellsLayer) {
            this.cellsLayer.clearLayers();
        }
        this.activeCell = null;
        this.allCells = []
    }

    drawAllCells(cells) {
        // Clear existing cells first
        this.clearCells();
        this.allCells = cells

        // Process each cell in the collection
        cells.forEach(cell => {
            if (cell.id) {
                // Create GeoJSON cell data
                let geometry = {
                    type: "Polygon",
                    coordinates: [
                        [
                            [cell.west, cell.north],
                            [cell.east, cell.north],
                            [cell.east, cell.south],
                            [cell.west, cell.south],
                            [cell.west, cell.north],
                        ],
                    ],
                };

                if (cell.coverage) {
                    const parsedGeom = utils.parseWKT(cell.coverage);
                    if (parsedGeom) {
                        geometry = parsedGeom;
                    }
                }

                const cellData = {
                    type: "Feature",
                    properties: {
                        id: cell.id,
                        name: cell.title || cell.name,
                        type: cell.type,
                    },
                    geometry: geometry,
                };

                // Display the cell
                this.displayCell(cellData);
            }
        });

        // Fit map to show all cells
        if (this.cellsLayer.getLayers().length > 0) {
            // Создаем группу для вычисления bounds
            const group = new L.featureGroup(this.cellsLayer.getLayers());
            this.map.fitBounds(group.getBounds());
        }
    }

    showRoute() {
        let points = this.routesStore.getShipWaypoints;

        console.log('FolioLeaf: drawing route with', points?.length || 0, 'points');
        console.log('FolioLeaf: route data:', points);
        console.log('FolioLeaf: routesStore state:', {
            hasResponse: !!this.routesStore.getShipResponse,
            calculatedRouteLegs: this.routesStore.getShipResponse?.calculatedRouteLegs?.length || 0,
            routeLength: this.routesStore.getShipResponse?.routeLength || 0
        });

        // Проверяем, что есть точки маршрута и группа инициализирована
        if (!points || points.length === 0) {
            console.log('FolioLeaf: no route points to display');
            return;
        }

        if (!this.routeGroup) {
            console.warn('FolioLeaf: routeGroup is not initialized, skipping route drawing');
            return;
        }

        console.log('FolioLeaf: drawing route with', points.length, 'points');

        points.forEach((point, index) => {

            let tooltip = 'WP' + index
            let isPermanent = false
            if (index === 0) {
                tooltip = "<div style='color:#16ba16;'>Start</div>"
                isPermanent = true
            } else if (index === points.length - 1) {
                tooltip = "<div style='color:#eda405;'>Finish</div>"
                isPermanent = true
            }

            let newMarker = new L.circleMarker([point.lat, point.lon], {
                bubblingMouseEvents: false,
                autoPan: true,
                radius: 4,
                weight: 15,
                opacity: 0,
                fillOpacity: 0.8,
                color: 'blue',
            }).bindTooltip(tooltip, {permanent: true, direction: 'top', offset: L.point(0, -4)})
                .addTo(this.routeGroup);

        });
        L.polyline(points, {color: 'blue', weight: 2}).addTo(this.routeGroup);
        this.initTooltips()
    }

    // Метод для отрисовки маркера корабля на карте
    drawShipMarker(position) {
        if (!this.map) {
            console.warn('drawShipMarker: map is not initialized');
            return;
        }

        // Удаляем предыдущий маркер корабля если он есть
        if (this.shipMarker) {
            this.map.removeLayer(this.shipMarker);
            this.shipMarker = null;
        }

        const course = Number(position.cog) || 0;
        const canvas = document.createElement('canvas');
        const cssWidth = 20;
        const cssHeight = 40;
        const dpr = window.devicePixelRatio || 1;
        canvas.width = cssWidth * dpr;
        canvas.height = cssHeight * dpr;
        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);

        drawShipIcon(ctx, {
            x: cssWidth / 2,
            y: cssHeight / 2,
            headingDeg: 0,
            scale: 0.72,
            fillColor: '#1d4ed8',
            strokeColor: '#bfdbfe',
            strokeWidth: 1.4,
            alpha: 0.95
        });

        const iconUrl = canvas.toDataURL('image/png');

        const shipIcon = L.divIcon({
            className: 'ship-icon-container',
            html: `<img src="${iconUrl}" width="${cssWidth}" height="${cssHeight}" style="transform: rotate(${course}deg); transform-origin: 50% 50%;" />`,
            iconSize: [cssWidth, cssHeight],
            iconAnchor: [cssWidth / 2, cssHeight / 2]
        });

        // Создаем маркер
        this.shipMarker = L.marker([position.lat, position.lon], {
            icon: shipIcon,
            zIndexOffset: 1000
        }).addTo(this.map);

        console.log('FolioLeaf: ship marker drawn at', position.lat, position.lon);
    }

    // Метод для полной очистки карты и освобождения ресурсов
    destroy() {
        try {
            // Очищаем все слои
            this.clearCells();

            // Удаляем маркер корабля
            if (this.shipMarker) {
                if (this.map) {
                    this.map.removeLayer(this.shipMarker);
                }
                this.shipMarker = null;
            }

            // Очищаем группу маршрутов
            if (this.routeGroup) {
                this.routeGroup.clearLayers();
                if (this.map && this.map.hasLayer(this.routeGroup)) {
                    this.map.removeLayer(this.routeGroup);
                }
                this.routeGroup = null;
            }

            // Очищаем слой ячеек
            if (this.cellsLayer) {
                this.cellsLayer.clearLayers();
                if (this.map && this.map.hasLayer(this.cellsLayer)) {
                    this.map.removeLayer(this.cellsLayer);
                }
                this.cellsLayer = null;
            }

            // Очищаем ссылки
            this.activeCell = null;
            this.allCells = null;

            // Вызываем родительский destroy
            super.destroy();

            console.log('FolioLeaf: all resources cleaned up');
        } catch (error) {
            console.warn('FolioLeaf: error while cleaning up resources', error);
        }
    }
}
